import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ToiletsFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M9 5.5C9 6.32843 8.32843 7 7.5 7C6.67157 7 6 6.32843 6 5.5C6 4.67157 6.67157 4 7.5 4C8.32843 4 9 4.67157 9 5.5ZM4 11.5C4 9.567 5.567 8 7.5 8C9.433 8 11 9.567 11 11.5V15H9.8V20H8V15H7V20H5.2V15H4V11.5ZM15.5 20V17H16.5V20H18.3V17H20L19.3313 10.9817C19.1427 9.28419 17.7079 8 16 8C14.2921 8 12.8573 9.28419 12.6687 10.9817L12 17H13.7V20H15.5ZM16 7C16.8284 7 17.5 6.32843 17.5 5.5C17.5 4.67157 16.8284 4 16 4C15.1716 4 14.5 4.67157 14.5 5.5C14.5 6.32843 15.1716 7 16 7Z"
      />
    </SvgIcon>
  );
});
